<template>
  <div class="app-kanban-column-header" :class="['header-' + variant, customClass]">
    <div class="kanban-header-top-row">
      <div class="kanban-header-title-group">
        <span class="kanban-header-icon" v-if="icon || $slots.icon">
          <slot name="icon">
            <AppIcon :name="icon" :size="15" />
          </slot>
        </span>
        <slot name="title">
          <span class="kanban-header-name">{{ title }}</span>
        </slot>
      </div>
      <slot name="count">
        <span class="kanban-header-count">{{ count }}</span>
      </slot>
    </div>

    <div class="kanban-header-bottom-row" v-if="subtitle || $slots.bottom || $slots.actions">
      <slot name="bottom">
        <span v-if="subtitle" class="kanban-header-subtitle">{{ subtitle }}</span>
      </slot>
      <div v-if="$slots.actions" class="kanban-header-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppKanbanColumnHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    count: {
      type: [Number, String],
      default: 0
    },
    icon: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "slate" // 'slate' | 'emerald' | 'rose' | 'sky' | 'amber'
    },
    subtitle: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.app-kanban-column-header {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.app-kanban-column-header:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

/* Variantes de gradientes */
.header-slate {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
}
.header-slate .kanban-header-icon { color: #38bdf8; }
.header-slate .kanban-header-count { background: rgba(255, 255, 255, 0.15); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.2); }

.header-emerald {
  background: linear-gradient(135deg, #064e3b 0%, #047857 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
}
.header-emerald .kanban-header-icon { color: #6ee7b7; }
.header-emerald .kanban-header-count { background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.25); }

.header-rose {
  background: linear-gradient(135deg, #881337 0%, #be123c 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
}
.header-rose .kanban-header-icon { color: #fecdd3; }
.header-rose .kanban-header-count { background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.25); }

.header-sky {
  background: linear-gradient(135deg, #0369a1 0%, #0284c7 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
}
.header-sky .kanban-header-icon { color: #bae6fd; }
.header-sky .kanban-header-count { background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.25); }

.header-amber {
  background: linear-gradient(135deg, #78350f 0%, #b45309 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
}
.header-amber .kanban-header-icon { color: #fde68a; }
.header-amber .kanban-header-count { background: rgba(255, 255, 255, 0.2); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.25); }

/* Linha superior */
.kanban-header-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.kanban-header-title-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kanban-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.kanban-header-name {
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.kanban-header-count {
  font-size: 11.5px;
  font-weight: 700;
  padding: 1px 9px;
  border-radius: 100px;
  min-width: 24px;
  text-align: center;
  letter-spacing: 0.2px;
}

/* Linha inferior */
.kanban-header-bottom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
}

.kanban-header-subtitle {
  font-size: 11.5px;
  color: #f8fafc;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.kanban-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
